export const ApplicationConstants = {
  ADD_APPLICATION_KEY: 'ADD_APPLICATION_KEY',
  UPDATE_APPLICATION_KEY: 'UPDATE_APPLICATION_KEY',
}
